import {
  EiendomRowDto,
  EiendomDto,
  IEiendomProps
} from "./eiendomTypes";
import React, { FC, FormEvent, useEffect, useState } from "react";
import Table, { ColumnDefinitionType } from "../table/Table";
import axios from "../../services/ApiConfig";
import { AxiosResponse } from "axios";
import FooterButtons from "../customhtmlcomponents/FooterButtons";
import { useHistory } from "react-router-dom";
import { URLS } from "../../utility/UrlConstants";
import NavigationBar from "../NavigationBar";
import { isBlank } from "../kos/Kos";
import Button from "../customhtmlcomponents/Button";
import {
  IntlNubmerFormatter,
  removeWhiteSpaces,
} from "../../utility/formatInputField";

const Eiendom: FC<IEiendomProps> = ({
  currentForeningReportNumber,
  username,
  message,
  setModal,
}) => {
  const [eiendomDto, setEiendomDto] = useState<EiendomDto>({
    foreningsNummer: currentForeningReportNumber.toString(),
    eiendomRows: []
  });

  const [
    foreningHarEiendommer,
    setForeningHarEiendommer,
  ] = useState(false);

  const [isSubmitting, setIsSubmitting] = useState(false);

  const onEiendomDtoReceived = (response: AxiosResponse<EiendomDto>) => {
    const { eiendomRows, foreningsNummer } = response.data;
    const eiendomRowsFormatted = eiendomRows.map((item) => ({
      ...item,
      antallBoenheter: IntlNubmerFormatter(item.antallBoenheter as number),
    }));
    const eiendomRowState = {
      foreningsNummer: foreningsNummer,
      eiendomRows: eiendomRowsFormatted
    };
    setEiendomDto(eiendomRowState);

    const eiendomRowDtos = eiendomRows.slice();
    if (eiendomRowDtos.length > 0) {
      setForeningHarEiendommer(true);
    }
  };

  useEffect(() => {
    const getEiendom = async () => {
      await axios
        .get(`${URLS.EIENDOM_GET}${currentForeningReportNumber}`, {
          headers: {
            Accept: "application/json",
            "Content-type": "application/json",
          },
        })
        .then(async (response: AxiosResponse<EiendomDto>) => {
          console.log(response);
          onEiendomDtoReceived(response)
        })
        .catch((error) => console.log(error));
    };
    getEiendom();

    console.log("dto", eiendomDto);
  }, []);

  const eiendomHandleChange = (e: any, row: any) => {
    const { name, value } = e.target;
    const { id } = row;
    const newItem = { ...row, [name]: value };
    const oldItems = eiendomDto.eiendomRows.slice();
    const index = oldItems.indexOf(row);
    const filteredItems = oldItems.filter((item: any) => item.id !== id);
    filteredItems.splice(index, 0, newItem);
    console.log("row", row);
    console.log(name, value);
    setEiendomDto((prevState) => ({
      ...prevState,
      eiendomRows: filteredItems,
    }));
  };
  const filterOutEmptyRows = () => {
    const eiendomRows = eiendomDto.eiendomRows
      .slice()
      .filter((k) => !isBlank(k.navn));
    return { eiendomRows };
  };

  function createFilteredDto() {
    const { eiendomRows } = filterOutEmptyRows();
    const removedWhiteSpacesEiendomRows = eiendomRows.map((item) => ({
      ...item,
      antallBoenheter: removeWhiteSpaces(item.antallBoenheter.toString()),
    }));
    const dto = {
      ...eiendomDto,
      eiendomRows: removedWhiteSpacesEiendomRows
    };
    console.log(dto);
    return dto;
  }

  const saveOnClick = async (e: React.BaseSyntheticEvent, link: string) => {
    e.preventDefault();
    setIsSubmitting(true);
    const filteredDto = createFilteredDto();
    axios
      .post<EiendomDto>(URLS.EIENDOM_POST, filteredDto)
      .then(() => {
        setIsSubmitting(false);
        saveSuccessMessage();
        history.push(link);
      })
      .catch((error) => {
        setIsSubmitting(false);
        console.log(error);
      });
  };
  const saveSuccessMessage = () => {
    message({
      body: {
        body: {
          message: `Dataen til Eiendom har blitt lagret.`,
        },
      },
    });
    setModal(true);
    setTimeout(() => setModal(false), 2650);
  };
  const history = useHistory();
  const submit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const filteredDto = createFilteredDto();
    axios
      .post<EiendomDto>(URLS.EIENDOM_POST, filteredDto, {
        headers: {
          Accept: "application/json",
          "Content-type": "application/json",
        },
      })
      .then((response) => {
        console.log(response);
        message({
          body: {
            body: {
              message: `Dataen til Eiendom har blitt lagret.`,
            },
          },
        });
        setModal(true);
        setTimeout(() => setModal(false), 2650);
        setTimeout(
          () =>
            history.push({
              pathname: "/aktiviteter",
              state: currentForeningReportNumber,
            }),
          2650
        );
      })
      .catch((error) => {
        message({
          body: {
            body: {
              error: error.response?.data
                ? error.response.data
                : "Beklager, noe gikk galt.",
            },
          },
        });
        console.log(error);
        setModal(true);
        setTimeout(() => setModal(false), 2650);
      });
  };

  const eiendomAddRow = () => {
    const newID = new Date().getMilliseconds().valueOf();
    const newRow: EiendomRowDto = {
      id: newID,
      navn: "",
      gbruksnummer: "",
      adresse: "", 
      kontaktPerson: "", 
      tlfKontaktPerson: "", 
      mailKontaktPerson: "", 
      kontrakterKlauser: "", 
      type: "",
      driftsform: "",
      antallBoenheter: "",
      leietaker: "", 
      kommentar: "",
      endringer: "",
      bokfortVerdi: 0, 
      ligningsVerdi: 0, 
      forsikringsVerdi: 0, 
      markedsVerdi: 0, 
      kvm: 0, 
      fastUtleidKvm: 0, 
      sporadiskUtleieKvm: 0, 
      dagerMedSporadiskUtleie: 0
    };

    setEiendomDto((prevState) => ({
      ...prevState,
      eiendomRows: [...prevState.eiendomRows, newRow],
    }));
  };

  const eiendomRemoveRow = (id: number) => {
    let toRemove = eiendomDto.eiendomRows;
    const minliste = toRemove.filter((eiendom) => eiendom.id !== id);
    setEiendomDto((prevState) => ({
      ...prevState,
      eiendomRows: minliste,
    }));
  };
  const eiendomColumns: ColumnDefinitionType<
    EiendomRowDto,
    keyof EiendomRowDto
  >[] = [
    {
      key: "navn",
      inputType: "text",
      header: "Navn på eiendom (flytt evnt adresse til det nye adresse feltet)",
      editAsAdminOnly: true
    },
    {
      key: "adresse",
      inputType: "text",
      header: "Adresse",
      editAsAdminOnly: true
    },
    {
      key: "gbruksnummer",
      inputType: "text",
      header: "Gårds og bruksnummer",
      editAsAdminOnly: true
    },
    {
      key: "antallBoenheter",
      inputType: "text",
      header: "Ant. boenheter",
      textStyle: "flex text-right mr-0 ml-auto pr-2",
      isNumberField: true,
      editAsAdminOnly: true
    },
    {
      key: "kontaktPerson",
      inputType: "text",
      header: "Kontaktperson",
      editAsAdminOnly: true
    },
    {
      key: "tlfKontaktPerson",
      inputType: "text",
      header: "Telefon kontaktperson",
      editAsAdminOnly: true
    },
    {
      key: "mailKontaktPerson",
      inputType: "text",
      header: "Mailadresse kontaktperson",
      editAsAdminOnly: true
    },
    {
      key: "type",
      inputType: "text",
      header: "Type eiendom",
      editAsAdminOnly: true
    },
    {
      key: "driftsform",
      inputType: "text",
      header: "Eierform",
      editAsAdminOnly: true
    },
    {
      key: "bokfortVerdi",
      inputType: "text",
      header: "Bøkført verdi",
      editAsAdminOnly: true,
      isNumberField: true
    }, 
    {
      key: "ligningsVerdi",
      inputType: "text",
      header: "Ligningsverdi",
      editAsAdminOnly: true,
      isNumberField: true
    },
    {
      key: "forsikringsVerdi",
      inputType: "text",
      header: "Forsikringsverdi",
      editAsAdminOnly: true,
      isNumberField: true
    },
    {
      key: "markedsVerdi",
      inputType: "text",
      header: "Markedsverdi",
      editAsAdminOnly: true,
      isNumberField: true
    }, 
    {
      key: "kvm",
      inputType: "text",
      header: "Totalt antall kvadratmeter",
      editAsAdminOnly: true,
      isNumberField: true
    },
    {
      key: "fastUtleidKvm",
      inputType: "text",
      header: "Antall kvadratmeter som leies ut fast",
      editAsAdminOnly: true,
      isNumberField: true
    },
    {
      key: "leietaker",
      inputType: "text",
      header: "Leietaker",
      editAsAdminOnly: true
    },
    {
      key: "sporadiskUtleieKvm",
      inputType: "text",
      header: "Antall kvadratmeter som leies ut sporadisk",
      editAsAdminOnly: true,
      isNumberField: true
    },
    {
      key: "dagerMedSporadiskUtleie",
      inputType: "text",
      header: "Antall dager med sporadisk utleie",
      editAsAdminOnly: true,
      isNumberField: true
    },
    {
      key: "kommentar",
      inputType: "text",
      header: "Kommentar",
    },
    
    {
      key: "endringer",
      inputType: "text",
      header: "Skriv inn endringer",
    },
  ];

  const popUp = (
    <div className="text-black text-xl font-bold mt-4 py-2 text-center">
      <p>Har du noen eiendommer?</p>
      <div className={"grid md:grid-cols-4 mt-6 grid-rows-4"}>
        <Button
          className={"md:col-start-2 rows-start-1"}
          onClick={(e) => setForeningHarEiendommer(true)}
        >
          JA
        </Button>
        <Button onClick={(e) => saveOnClick(e, "/aktiviteter")}>NEI</Button>
      </div>
    </div>
  );

  const isAdmin = username === "1";

  return (
    <>
      <NavigationBar saveOnClick={saveOnClick} />
      {!foreningHarEiendommer ? (
        popUp
      ) : (
        <form onSubmit={submit}>
          <div className="bg-sk-tertiary-red">
            <div>
              <p className="text-black text-center text-2xl font-bold mt-2  p">
                3. Eiendom
              </p>
            </div>
            <div className="">
              <div className="bg-sk-button-selected border border-sk-secondary-blue rounded-md shadow-2xl transform scale-100 md:scale-75 pb-8">
                <div>
                  <p className="text-black text-center text-2xl font-bold mt-4 py-2 p-8">
                    3.1 Foreningen eier disse eiendommene
                  </p>
                </div>
                <Table
                  handleChange={eiendomHandleChange}
                  data={eiendomDto.eiendomRows}
                  columns={eiendomColumns}
                  removeRow={eiendomRemoveRow}
                  addRow={eiendomAddRow}
                  isAdmin={isAdmin}
                  rowActionsAsAdminOnly={true}
                  useVerticalRows={true}
                  entityName="Eiendom"
                />
              </div>
            </div>
            {/*This is the go back and forward buttons*/}
            <FooterButtons
              previousLocation="/styret"
              saveOnClick={saveOnClick}
              isSubmitting={isSubmitting}
            />
          </div>
        </form>
      )}
    </>
  );
};

export default Eiendom;
